<template>
  <div
    :class="className"
    class="row">
    <div class="col-9 column">
      <span class="name"><slot/></span>
    </div>
    <div class="col-3 column justify-content-end">
      <ActionButton
        :class="{'btn-primary': type == 'add', 'btn-danger': type == 'delete'}"
        class="btn d-inline-block btn-icon"
        @click="$emit('click')">
        <i :class="{'fas fa-plus ': type == 'add', 'fas fa-minus': type == 'delete'}"/>
      </ActionButton>
    </div>
  </div>
</template>

<script>
import ActionButton from '@/components/Actions/ActionButton';

export default {
  name: 'TextAction',
  components: {
    ActionButton,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    className: {
      type: String,
      default: '',
    },
  },
  methods: {},
};
</script>

<style scoped lang="scss">
div {
  &.column {
    display: flex;
    align-items: center;
  }
}

span {
  &.name {
    color: $primary;
  }
}
</style>
